





import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ListItem from "./PendingActionList.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { ReportFilter, ReportParameter } from "@/entities";
import { Utilities as utils } from "@/shared/utilities";

const namespace: string = "Dashboard";

@Component({ components: { ListItem } })
export default class PendingActionComponent extends Vue {
  items:any;
  dataLoaded: boolean = false;
  fields: Array<ReportFilter> = [];
  selectedParams: Array<ReportParameter> = [];

  mounted() {
      this.$services.commiunicationReport
      .GetDashboard().then(data=>{
          this.items=data.map(x =>  {
          x.EndDate = x.EndDate ? utils.formatDate(x.EndDate) : ""; 
          x.Expiry=x.Expierd?`${Math.abs(x.Expiry)} days overdue`:x.Expiry;
          return x;
         });
        this.dataLoaded=true
      })
  }

  onSearch(selValue) {
    this.$emit("search", this.selectedParams);
  }

 /** check button access rights */
 accessRights(card, btn) {
    // TO DO: Access check
    return true;
}

}
